import React from "react";
import "../Styles/NotificationToggleCell.scss";

interface NotificationToggleCellProps {
  configured: boolean;
  checked: boolean;
  ariaLabel: string;
  onChange: (_checked: boolean) => void;
}

const NotificationToggleCell: React.FC<NotificationToggleCellProps> = ({
  configured,
  checked,
  ariaLabel,
  onChange,
}) => (
  <td className="toggle-cell">
    <label
      className={`notif-toggle${configured ? "" : " notif-toggle--disabled"}`}
      aria-label={ariaLabel}
    >
      <input
        type="checkbox"
        checked={checked}
        disabled={!configured}
        onChange={e => onChange(e.target.checked)}
      />
      <span className="notif-toggle-slider" />
    </label>
  </td>
);

export default NotificationToggleCell;
